/* ============
 * Members Page
 * ============
 *
 * This is the page for members.
 */
import Vue from 'vue';
import Moment from 'moment';

export default {
  data: () => ({ 
    loading: true,
    organization_products: [],
    member: null,
    timeslot_gap: '00:10',

    addProduct: false,
    new_product_id: null,
    deleteMemberProduct: false,
    product_delete_id: '',

    deleteMember: false,

    addTimeVisible: false,
    day: '',
    start_time: '',
    end_time: '',

    selected_product: null,

    days: [
      'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
    ]
  }),
  
  computed: {
    acceptStatus() {
      var status = '';
      if (this.member.is_accepted) {
        status = 'ACTIVE';
      } else {
        status = 'PENDING';
      }
      return status;
    }
  },

  mounted() {
    Vue.$http.get('/membership/member/'+this.$route.params.id).then(data => {
      this.member = data.data.organization_member;
      this.organization_products = data.data.organization_products;
      this.timeslot_gap = '00:' + data.data.organization_member.organization.organization_settings.timeslot_gap;
      this.loading = false;
    });

  },

  methods: {
    formatDate(date) {
      if (!date) return '';
      return Moment(date).format('MMM DD, YYYY');
    },

    setDay(day) {
      this.day = day;
    },

    removeHour(id) {
      Vue.$http.delete('/membership/member/business_hours/' + id).then(data => {
        this.selected_product.business_hours.splice(this.selected_product.business_hours.findIndex(x => x.id == id), 1);
      });
    },

    confirmAddTime() {
      if (this.start_time && this.end_time) {
        Vue.$http.post('/membership/member/'+this.member.id+'/business_hours', {
          'organization_member_product_id': this.selected_product.id,
          'day': this.day,
          'start_time': this.start_time,
          'end_time': this.end_time,
        }).then(data => {
          this.selected_product.business_hours.push(data.data);
        });
        this.addTimeVisible = false;
        this.start_time = this.end_time = '';
      }
    },

    showAddHour(index) {
      this.addTimeVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput[index].$refs.reference.focus();
      });
    },

    getHours(product, day) {
      return product.business_hours.filter(x => x.day == day);
    },

    selectProduct(product) {
      this.day = '';
      this.selected_product = product;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/membership/show/show.js